import * as _ from 'lodash';
import { ICalendarStateAction } from "@adage/ace-calendar";
import { ExtendedActionType } from "../actions";

export interface ILazyLoaderState {
    imageHasLoaded: {
        [monthString: string]: { [id: string]: boolean }
    };
    imagesToLoad: { [monthString: string]: boolean };
    elements: { [month: string]: HTMLElement };
}

export const defaultLazyLoaderState: ILazyLoaderState = {
    imageHasLoaded: {},
    imagesToLoad: {},
    elements: {}
}

export default function lazyLoaderReducer(state: ILazyLoaderState = defaultLazyLoaderState, action: ICalendarStateAction) {
    switch (action.type) {
        case ExtendedActionType.WaitForImage: {
            const monthString = action.value.monthString as string;
            const id = action.value.id as string;

            let imageHasLoaded = _.assign({}, state.imageHasLoaded);

            let imagesInMonth = imageHasLoaded[monthString];

            if (!imageHasLoaded[monthString]) {
                imageHasLoaded[monthString] = {};
            }
            imageHasLoaded[monthString][id] = false;

            return _.assign({}, state, {
                imageHasLoaded: imageHasLoaded
            });
        }
        case ExtendedActionType.ImageHasLoaded: {
            const monthString = action.value.monthString as string;
            const id = action.value.id as string;

            let imageHasLoaded = _.assign({}, state.imageHasLoaded);

            let imagesInMonth = imageHasLoaded[monthString];

            if (!imageHasLoaded[monthString]) {
                imageHasLoaded[monthString] = {};
            }
            imageHasLoaded[monthString][id] = true;

            return _.assign({}, state, {
                imageHasLoaded: imageHasLoaded
            });
        }
        case ExtendedActionType.AddNewImagesToLoad: {
            const dateStrings = action.value as Array<string>;
            const imagesToLoad = _.assign({}, state.imagesToLoad);
            let allMonthsExist = dateStrings.every(dateString => dateString in imagesToLoad);

            // Only update the state if there are new months to load images for.
            if (!allMonthsExist) {
                dateStrings.forEach(dateString => imagesToLoad[dateString] = true);
                return _.assign({}, state, { imagesToLoad });
            }

            return state;
        }
        case ExtendedActionType.UpdateMonthElements: {
            const monthString: string = action.value.month;
            const element: HTMLElement = action.value.element;

            const elements = _.assign({}, state.elements);

            if (monthString in elements && _.isEqual(elements[monthString], element)) {
                return state;
            } else {
                elements[monthString] = element;

                return _.assign({}, state, { elements: elements });
            }
        }
        case ExtendedActionType.ClearMonthElements: {
            return _.assign({}, state, {
                elements: {}
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/reducers/lazy-loader-reducer.ts